import { render, staticRenderFns } from "./TraineesManagerTableWidget.vue?vue&type=template&id=67b568fc"
import script from "./TraineesManagerTableWidget.vue?vue&type=script&lang=js"
export * from "./TraineesManagerTableWidget.vue?vue&type=script&lang=js"
import style0 from "./TraineesManagerTableWidget.vue?vue&type=style&index=0&id=67b568fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports